import React, { useState, useEffect, useCallback } from "react";
// @ts-ignore

import Table from "./Table/Table";
import Sidebar from "../../../../CommonComponets/SideBar";
import { MdAddCircleOutline, MdClose, MdFilterListOff } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import useApiRequest from "../../../../Hooks/apiReq";
import TableSkeleton from "./Table/TableSkeleton";
import Buttonbox from "../../../../Shared/ButtonBox/Buttonbox";
import styles from "./UserList.module.css";
import { useSelector } from "react-redux";
const BusinessAddCustomer = React.lazy(
  () => import("../../Pages/CustomerArea/AddCustomer/AddCustomer"),
);
const PromoteAsAssociate = React.lazy(
  () =>
    import("../../Pages/CustomerArea/PromoteAsAssociate/PromoteAsAssociate"),
);

const UserListBussiness = () => {
  const [activeTab, setActiveTab] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState("All");
  const [isCustomerAdd, setIsCustomer] = useState(false);
  const [promoteAsAssociate, setpromoteAsAssociate] = useState(false);
  const [totalRows, setTotalRows] = useState(1);
  const associateProfileDetails = useSelector(
    (state) => state.assoProfileDetails.profileDetails,
  );

  // pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Data State
  const [customerData, setCustomerData] = useState([]);

  const navigate = useNavigate();
  const { sendApiRequest, loading: apiLoading } = useApiRequest();
  // --- API Call Logic ---
  const fetchCustomerList = useCallback(() => {
    const apiFilter = activeTab === "All" ? "" : activeTab;
    const payload = {
      Mode: "SELECT",
      Status: activeTab === "Active" ? "Y" : "",
      KycFilter:
        activeTab != "Active" &&
        activeTab !== "0" &&
        activeTab !== "1" &&
        activeTab !== "Promoted"
          ? apiFilter
          : "",
      IsPurchaseProperty: activeTab == "0" || activeTab == "1" ? activeTab : "",
      IsPromotedCustomer: activeTab === "Promoted" ? "1" : "",
      SearchKey: searchTerm,
      CustomerType: selectedRole === "All" ? "" : selectedRole,
      PageSize:
        searchTerm || selectedRole === "Y" || activeTab === "Promoted"
          ? "10"
          : `${itemsPerPage}`,
      PageNumber:
        searchTerm || selectedRole === "Y" || activeTab === "Promoted"
          ? "1"
          : `${currentPage}`,
    };
    // console.log(payload);
    sendApiRequest("POST", "/CustomerArea/GetCustomerList", payload, {
      onSuccess: (res) => {
        const parsedData = res?.data?.jsondata
          ? JSON.parse(res?.data?.jsondata)
          : [];
        setTotalRows(res?.data?.totalRecords);
        setCustomerData(parsedData);
      },
      onStatus3: () => navigate("/login"),
    });
  }, [activeTab, searchTerm, selectedRole, currentPage, itemsPerPage]);
  // Trigger API call when any filter changes
  useEffect(() => {
    // Debounce search to avoid too many API calls while typing
    const delayDebounceFn = setTimeout(() => {
      fetchCustomerList();
    }, 100);
    return () => clearTimeout(delayDebounceFn);
  }, [activeTab, searchTerm, selectedRole, currentPage, itemsPerPage]);

  const [promotingUserData, setPromotingUserData] = useState({});
  // --- Logic: Clear All Filters ---
  const handleClearAll = () => {
    setActiveTab("All");
    setSearchTerm("");
    setSelectedRole("All");
  };

  const isFilterActive =
    activeTab !== "All" || searchTerm !== "" || selectedRole !== "All";

  // --- Dynamic Tab Logic ---
  // Note: For real counts, your API should ideally return these counts.
  // If not, these will only reflect the current filtered set.

  const tabs = [
    { label: "All", color: "#3b82f6" },
    { label: "Last 30 Days", color: "#fce8e6" },
    { label: "Last 60 Days", color: "#fce8e6" },
    { label: "KYC Pending", color: "#fff7e6" },
    { label: "Property Customer", lable2: "1", color: "#f1f3f4" },
    { label: "Non Property Customer", lable2: "0", color: "#f1f3f4" },
    { label: "Promoted Customer", lable2: "Promoted", color: "#f1f3f4" },
  ];
  const handlePromoteAsAssociate = (data) => {
    setpromoteAsAssociate(true);
    setPromotingUserData(data);
  };
  return (
    <div className={`${styles.container}   content`}>
      <header className={styles.header}>
        <div className={styles.titleArea}>
          <h1>Customer List</h1>
          <p className={styles.subTitle}>Manage and monitor your customer.</p>
        </div>
        {/* <button
          className={styles.addButton}
          onClick={() => setIsCustomer(true)}
        >
          <MdAddCircleOutline className={styles.btnIcon} /> 
        </button> */}
        <Buttonbox
          handleClick={() => setIsCustomer(true)}
          text={"Add Customer"}
        />
      </header>

      {/* Sidebars */}
      {isCustomerAdd && (
        <Sidebar
          setIsFilter={() => setIsCustomer(false)}
          heading="Add New Customer"
        >
          <React.Suspense fallback={<div>Loading...</div>}>
            <BusinessAddCustomer
              setIsCustomer={setIsCustomer}
              getCustomerList={fetchCustomerList}
            />
          </React.Suspense>
        </Sidebar>
      )}

      {promoteAsAssociate && (
        <Sidebar setIsFilter={() => setpromoteAsAssociate(false)}>
          <React.Suspense fallback={<div>Loading...</div>}>
            <PromoteAsAssociate
              defaultValues={{
                ...promotingUserData,
                referBy: associateProfileDetails?.assoCode,
                associateName:
                  associateProfileDetails?.solutation +
                  " " +
                  associateProfileDetails?.fullName,
                refAssoID: associateProfileDetails?.associateID,
              }}
              setIsPromoting={setpromoteAsAssociate}
              getCustomerList={fetchCustomerList}
            />
          </React.Suspense>
        </Sidebar>
      )}

      {/* Tabs Section */}
      <div className={styles.tabsContainer}>
        {tabs.map((tab, i) => (
          <button
            key={tab.label}
            className={`${styles.tab} ${activeTab === tab.label || activeTab === tab.lable2 ? styles.activeTab : ""}`}
            style={
              activeTab === tab.label || activeTab === tab.lable2
                ? { borderBottomColor: tab.color }
                : {}
            }
            onClick={() =>
              i > 3 ? setActiveTab(tab.lable2) : setActiveTab(tab.label)
            }
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Filters Section */}

      <div className={styles.filterInputs}>
        <select
          className={styles.select}
          value={selectedRole}
          onChange={(e) => setSelectedRole(e.target.value)}
        >
          <option value="All">All Customers</option>
          <option value="Y">Self Customer</option>
          <option value="N">Refer Customer</option>
        </select>

        <div className={styles.searchWrapper}>
          <input
            type="search"
            placeholder="Search by name,code,primary phone or email..."
            className={styles.searchInput}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Chips */}
      {isFilterActive && (
        <div className={styles.chipsContainer}>
          {activeTab !== "All" && (
            <div className={styles.chip}>
              Filter: {activeTab}{" "}
              <MdClose onClick={() => setActiveTab("All")} />
            </div>
          )}
          {selectedRole !== "All" && (
            <div className={styles.chip}>
              Type: {selectedRole === "Y" ? "Self" : "Refer"}{" "}
              <MdClose onClick={() => setSelectedRole("All")} />
            </div>
          )}
          {searchTerm && (
            <div className={styles.chip}>
              Search: "{searchTerm}"{" "}
              <MdClose onClick={() => setSearchTerm("")} />
            </div>
          )}
          <div
            className={`${styles.chip} ${styles.clearAllBtn}`}
            onClick={handleClearAll}
          >
            <MdFilterListOff /> Clear All
          </div>
        </div>
      )}
      {/* Table Section */}
      {
        <Table
          users={customerData}
          loading={apiLoading}
          handlePromoteAsAssociate={handlePromoteAsAssociate}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          totalPage={totalRows}
          activeTab={activeTab}
          CustomerType={selectedRole}
        />
      }
    </div>
  );
};

export default UserListBussiness;
